import React from 'react';
import {
  BrowserRouter
} from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

/*
import {loadStripe} from '@stripe/stripe-js';
import {
  CardElement,
  Elements,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';*/

global.country = 'CD';
global.continent = 'AF';
global.ip = '';
global.reloadobj = null;
global.rate = 2060;

global.displayModal = false;
global.selectedFilter = '';
global.menuFilterClicked = false;

//const stripePromise = loadStripe('pk_live_1NtV1g1sGnZEVL2BfkAxsSiu');
//const stripePromise = loadStripe('pk_test_6qz6Ir009Ktjzv1MIRZBATUV');




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
     <BrowserRouter>
        <App />
     </BrowserRouter>
);
